import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { CircleNotch } from "@phosphor-icons/react";

import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import NewProject from "@/pages/NewProject";
import ProjectFlow from "@/pages/ProjectFlow";
import ProjectDetail from "@/pages/ProjectDetail";
import Domains from "@/pages/Domains";
import Usage from "@/pages/Usage";
import Billing from "@/pages/Billing";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import OwnerInfrastructure from "@/pages/OwnerInfrastructure";

function Splash() {
  return <div className="grid min-h-screen place-items-center bg-background"><CircleNotch size={32} className="animate-spin text-muted-foreground" /></div>;
}

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Public({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Splash />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function OwnerRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_owner) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/register" element={<Public><Register /></Public>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/projects" element={<Protected><Projects /></Protected>} />
            <Route path="/new" element={<Protected><NewProject /></Protected>} />
            <Route path="/projects/:id/flow" element={<Protected><ProjectFlow /></Protected>} />
            <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="/domains" element={<Protected><Domains /></Protected>} />
            <Route path="/usage" element={<Protected><Usage /></Protected>} />
            <Route path="/billing" element={<Protected><Billing /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="/owner/infrastructure" element={<OwnerRoute><OwnerInfrastructure /></OwnerRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
